// src/sections/Features.jsx
import Section from "../components/ui/Section";
import Badge from "../components/ui/Badge";
import { Smile, Wrench, Euro, Award, Heart, CheckCircle2, ShieldCheck } from "lucide-react";

const features = [
    {
        title: "Einfacher Aufbau",
        text: "Der Zusammenbau meiner Betonrohrfalle gestaltet sich praxisnah, intuitiv und vollkommen unkompliziert.",
        icon: Smile,
        tags: ["Leicht", "Schnell"]
    },
    {
        title: "Absolut Wartungsfrei",
        text: "Über vier Jahrzehnte erfolgreich bewährt – ohne Reparaturen oder teuren Wartungsaufwand im direkten Feldeinsatz.",
        icon: Wrench,
        tags: ["Langlebig", "Robust"]
    },
    {
        title: "Faires Preismodell",
        text: "Fachwissen und bewährte Qualität kombiniert mit einem exzellenten Preis-Leistungs-Verhältnis für Jäger.",
        icon: Euro,
        tags: ["Fair", "Direkt-Vertrieb"]
    },
];

export default function Features() {
    return (
        <Section 
            className="py-20 lg:py-32 relative overflow-hidden" 
            eyebrow="Qualitätsmerkmale" 
            title="Meine Vorteile" 
            lead="Warum passionierte Jäger und Reviere seit Jahrzehnten auf mein System vertrauen."
        >
            {/* Background Background */}
            <div className="pointer-events-none absolute inset-0 -z-10 bg-slate-50/50 dark:bg-transparent" />

            <div className="grid gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-3 pt-12 relative z-10">
                {features.map((f, i) => (
                    <div 
                        key={i}
                        data-aos="fade-up"
                        data-aos-delay={i * 100}
                        className="group relative flex flex-col p-8 rounded-3xl bg-white dark:bg-slate-900 border-2 border-slate-100 dark:border-slate-800 hover:border-brand-200 dark:hover:border-brand-800 transition-all duration-300 hover:shadow-xl hover:shadow-brand-500/10"
                    >
                        {/* Icon */}
                        <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-100 dark:bg-brand-900/40 text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition-all duration-300">
                            <f.icon className="h-7 w-7" />
                        </div>

                        {/* Tags */}
                        <div className="flex flex-wrap gap-2 mb-4">
                            {f.tags.map(t => (
                                <span key={t} className="text-[10px] font-bold uppercase tracking-wider text-brand-600 bg-brand-50 dark:bg-brand-950/50 px-2.5 py-1 rounded-full">{t}</span>
                            ))}
                        </div>
                        
                        <h3 className="text-xl font-heading font-bold text-slate-900 dark:text-white mb-3">
                            {f.title}
                        </h3>
                        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed flex-1">
                            {f.text}
                        </p>

                        {/* Bottom indicator */}
                        <div className="mt-6 pt-4 border-t border-slate-100 dark:border-slate-800">
                            <div className="flex items-center gap-2 text-xs font-bold text-brand-600">
                                <CheckCircle2 className="h-4 w-4" />
                                Praxisgeprüft
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Sub-Footer Trust Elements */}
            <div data-aos="fade-up" className="mt-20 flex flex-wrap justify-center items-center gap-x-12 gap-y-6 pt-12 border-t border-slate-100 dark:border-slate-800">
                <div className="flex items-center gap-3 text-xs font-bold text-slate-400 uppercase tracking-widest">
                    <Award className="h-5 w-5 text-brand-600" />
                    50 JAHRE ERFAHRUNG
                </div>
                <div className="flex items-center gap-3 text-xs font-bold text-slate-400 uppercase tracking-widest">
                    <Heart className="h-5 w-5 text-brand-600" />
                    VOM JÄGERN FÜR JÄGER
                </div>
                <div className="flex items-center gap-3 text-xs font-bold text-slate-400 uppercase tracking-widest">
                    <ShieldCheck className="h-5 w-5 text-brand-600" />
                    HANDARBEIT AUS DEUTSCHLAND
                </div>
            </div>
        </Section>
    );
}
